import './style/index.less';
import Requirement from './Requirement';

export default Requirement;
